import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import TagManager from "react-gtm-module";

import App from "components/App/App";
import env from "consts/env";

import "./index.scss";
import * as serviceWorker from "./serviceWorker";

const tagManagerArgs = {
  gtmId: "GTM-MMXC5GC",
};

if (env.IS_PRODUCTION) {
  TagManager.initialize(tagManagerArgs);
}

if (env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: env.ENVIRONMENT,
    release: `@deeptrue-frontend/dashboard@${env.BUILD_VERSION}`,
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
